// extracted by mini-css-extract-plugin
module.exports = {"section":"PaginaInicial_section__3jnmE","welcome":"PaginaInicial_welcome__3BD8q","headerText":"PaginaInicial_headerText__VRq2b","mainText":"PaginaInicial_mainText__3yB7C"};